export default __webpack_public_path__ + "static/media/Voidcage.91c19924.jpg";